/**
 * Cambiar la contraseña.
 *
 * Se usa de dos maneras:
 *   * desde el menú, cuando la persona quiere cambiarla
 *   * obligatoria, la primera vez que entra alguien con una clave que le
 *     dieron: hasta que no la cambia, el sistema no le muestra nada
 *
 * El freno de la primera vez está también en el servidor. Acá se muestra la
 * pantalla; allá se rechaza cualquier otro pedido.
 */

function alerta(tipo, texto) {
  const simbolos = { critico: '!', aviso: '!', bien: '✓' };
  const div = document.createElement('div');
  div.className = `alerta ${tipo}`;
  div.setAttribute('role', tipo === 'critico' ? 'alert' : 'status');
  div.innerHTML = `<span class="simbolo" aria-hidden="true">${simbolos[tipo] ?? '·'}</span><span></span>`;
  div.lastElementChild.textContent = texto;
  return div;
}

const FORMULARIO = (obligatorio) => `
  <div data-rol="errores"></div>
  <!-- method="post": si el JavaScript no carga, el navegador no puede mandar
       las contraseñas por la barra de direcciones. -->
  <form method="post" action="/api/cambiar-clave" novalidate autocomplete="off">
    <div class="campo">
      <label for="clave-actual">Contraseña actual</label>
      <input type="password" id="clave-actual" name="claveActual"
             autocomplete="current-password" required>
      <div class="ayuda">${obligatorio
        ? 'Es la que te dieron para entrar la primera vez.'
        : 'Para confirmar que sos vos.'}</div>
    </div>
    <div class="campo">
      <label for="clave-nueva">Contraseña nueva</label>
      <input type="password" id="clave-nueva" name="claveNueva"
             autocomplete="new-password" required>
      <div class="ayuda">Al menos 10 caracteres. Elegí una que no uses en otro lado.</div>
    </div>
    <div class="campo">
      <label for="clave-nueva-2">Repetir la contraseña nueva</label>
      <input type="password" id="clave-nueva-2" name="claveNuevaRepetida"
             autocomplete="new-password" required>
      <div class="ayuda">Se pide dos veces para que un error de tipeo no te deje afuera.</div>
    </div>
    <button type="submit" class="boton principal" id="boton-cambiar-clave">
      ${obligatorio ? 'Guardar y entrar' : 'Cambiar la contraseña'}
    </button>
  </form>`;

/**
 * Dibuja el formulario.
 *
 * @param contenedor  dónde ponerlo
 * @param opciones.pedir        para hablar con la API
 * @param opciones.obligatorio  true si es la primera vez y no puede saltearlo
 * @param opciones.alTerminar   qué hacer después de cambiarla
 */
export function pantallaDeCambioDeClave(contenedor, { pedir, obligatorio = false, alTerminar }) {
  const tarjeta = document.createElement('div');
  tarjeta.className = 'tarjeta';
  tarjeta.style.maxWidth = '460px';
  tarjeta.innerHTML = `
    <h2 style="font-size:16px;margin:0 0 4px">
      ${obligatorio ? 'Elegí tu contraseña' : 'Cambiar mi contraseña'}</h2>
    <p style="color:var(--texto-suave);font-size:13px;margin:0 0 16px">
      Al cambiarla se cierran las sesiones abiertas en otros dispositivos.
      La que estás usando ahora sigue abierta.</p>
    ${FORMULARIO(obligatorio)}`;

  if (obligatorio) {
    contenedor.appendChild(alerta('aviso',
      'Antes de empezar tenés que elegir tu propia contraseña. La que te dieron ' +
      'la conoce quien te la mandó y quedó escrita en ese mensaje.'));
  }
  contenedor.appendChild(tarjeta);

  const cajaErrores = tarjeta.querySelector('[data-rol="errores"]');
  const boton = tarjeta.querySelector('#boton-cambiar-clave');
  const textoOriginal = boton.textContent.trim();

  tarjeta.querySelector('form').addEventListener('submit', async (evento) => {
    evento.preventDefault();
    cajaErrores.innerHTML = '';
    boton.disabled = true;
    boton.textContent = 'Guardando…';

    const form = evento.target;
    const datos = {
      claveActual: form.elements['claveActual'].value,
      claveNueva: form.elements['claveNueva'].value,
      claveNuevaRepetida: form.elements['claveNuevaRepetida'].value,
    };

    try {
      const r = await pedir('/api/cambiar-clave',
        { method: 'POST', body: JSON.stringify(datos) });

      if (r.ok) {
        form.reset();
        cajaErrores.appendChild(alerta('bien', r.cuerpo?.mensaje ?? 'Contraseña cambiada.'));
        if (alTerminar) setTimeout(() => { void alTerminar(); }, 1200);
        return;
      }
      if (r.cuerpo?.errores) {
        for (const e of r.cuerpo.errores) {
          cajaErrores.appendChild(alerta('critico', `${e.rotulo}: ${e.problema}`));
        }
      } else {
        cajaErrores.appendChild(alerta('critico',
          r.cuerpo?.error ?? 'No se pudo cambiar la contraseña.'));
      }
    } finally {
      boton.disabled = false;
      boton.textContent = textoOriginal;
    }
  });
}
